export default new class {
  constructor() {
    const isAuth = !!document.querySelector('.user-activity__avatar')
    if (!isAuth) return;

    this.DELAY = 1000 * 10
    this.EVENTS = ['scroll', 'mousedown']
    this.timer = undefined;

    this.initAuthHandler()
  }

  initAuthHandler() {
    this.EVENTS.forEach(event => {
      document.addEventListener(event, () => {
        this.checkAuth()
      })
    })
  }

  checkAuth() {
    if (this.timer) return
    this.timer = setTimeout(() => {
      $.request('UserData::onCheckAuth', {
        success: (data) => {
          if (!data.status) {
            this.showLogoutModal()
          }
        }
      })
      this.timer = undefined;
    }, this.DELAY)
  }

  showLogoutModal() {
    if (document.querySelector('.logout-modal')) return;
    const logOutModal = this.createModal();
    document.body.append(logOutModal);
  }


  createModal() {
    const modalWrapper = document.createElement('section')
    modalWrapper.classList.add('expired-modal')
    modalWrapper.classList.add('logout-modal')
    modalWrapper.style.display = 'flex'
    modalWrapper.style.justifyContent = 'center'
    modalWrapper.style.alignItems = 'center'

    const modalBox = document.createElement('div')
    modalBox.classList.add('expired-modal__body')

    const modalHeading = document.createElement('div')
    modalHeading.classList.add('expired-modal__head')
    modalHeading.innerText = 'Вы авторизовались с другого устройства'

    const modalButton = document.createElement('button')
    modalButton.classList.add('expired-modal__btn-red');
    modalButton.classList.add('btn-close');
    modalButton.innerText = 'Ок';

    modalButton.onclick = function () {
      location.reload();
    }

    modalBox.append(modalHeading, modalButton)
    modalWrapper.append(modalBox)

    return modalWrapper
  }
}();
